import React from 'react';
import type PlanSettingsRemovedIssuesType from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/removed-issues/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

/**
 * Plan Settings - removed-issues page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanSettingsRemovedIssues = lazyForPaint<typeof PlanSettingsRemovedIssuesType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-settings-removed-issues", jiraSpaEntry: "async-plan-settings-removed-issues" */ '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/removed-issues'
			),
		),
	{ ssr: false },
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyPlanSettingsRemovedIssues}
		pageId="plan-settings-removed-issues"
		shouldShowSpinner
	/>
);
